import { isVideoArticlePage } from '../../utils/aem-utils';
import { VIDEO_PLAYER_PLAYERTYPE } from '../video-player/constants';
import { isMobile, isWidthDeviceMobileTablet, isWidthDeviceTablet } from '../../utils/device-utils';
import { satelliteTracker } from '../../services/tracking/satellite-tracking-service';
import { hideElement, unHideElement } from '../../utils/dom-utils';

import { stickyHeroPlayerState } from './state';
import {
  $heroStickyPlayerWrapper,
  $F1Hero,
  $globalNav,
  $LMPHero,
  $LMPPlayerWrapperMobile,
  $player,
  $playerContainer,
  $sectionDividerSpecial,
  HERO_STICKY_PLAYER_WRAPPER_LMP_CLASSNAME,
  HERO_STICKY_PLAYER_WRAPPER_CLASSNAME,
  MEDIA_WRAPPER_TOP_BG_CLASSNAME,
  MOBILE_STICKY_WRAPPER_TOP_VALUE,
  PLAYER_CLOSE_BUTTON_CLASSNAME,
  PROGRESS_BAR_CLASSNAME_SELECTOR,
} from './constants';
import { stickyHeroPlayerDisclaimer } from './sticky-hero-player';

export const isLMPArticle = $LMPHero || $F1Hero;

export const isSticky = () =>
  $heroStickyPlayerWrapper.classList.contains(HERO_STICKY_PLAYER_WRAPPER_CLASSNAME) ||
  $heroStickyPlayerWrapper.classList.contains(HERO_STICKY_PLAYER_WRAPPER_LMP_CLASSNAME);

export const getVideoPlayer = (players) => {
  let playerInstance;
  players?.playerConfigList?.forEach((playerConfig, index) => {
    if (
      playerConfig.playersetup.playertype === VIDEO_PLAYER_PLAYERTYPE.HERO ||
      playerConfig.playersetup.playertype === VIDEO_PLAYER_PLAYERTYPE.LMP_STICKY
    ) {
      playerInstance = players.playerList[index];
    }
  });
  return playerInstance;
};

// without the need to use three different intersection obsverver, we can use a single one
// by dynamically changing the treshold value based on the page type
export const getMobileTreshold = () => {
  switch (true) {
    case isMobile() && Boolean($sectionDividerSpecial) && !isLMPArticle:
      return 0.2;
    case isLMPArticle:
      return 0.6;
    default:
      return 0.3;
  }
};

export const isReadingProgressInPage = () => {
  return Boolean(document.querySelector(PROGRESS_BAR_CLASSNAME_SELECTOR));
};

export const enableStickyElement = () => {
  const $playerCloseButton = $player.querySelector(`.${PLAYER_CLOSE_BUTTON_CLASSNAME}`);
  if ($playerCloseButton) {
    unHideElement($playerCloseButton);
  }
  if (isMobile() && !isWidthDeviceTablet() && !isLMPArticle) {
    $heroStickyPlayerWrapper.style.height = $player.style.height;
    $heroStickyPlayerWrapper.style.top = `${MOBILE_STICKY_WRAPPER_TOP_VALUE}px`;
    if (!isReadingProgressInPage()) {
      $heroStickyPlayerWrapper.classList.add(MEDIA_WRAPPER_TOP_BG_CLASSNAME);
    }
  }

  $heroStickyPlayerWrapper.classList.add(
    isMobile() && isLMPArticle ? HERO_STICKY_PLAYER_WRAPPER_LMP_CLASSNAME : HERO_STICKY_PLAYER_WRAPPER_CLASSNAME
  );

  if ($player.dataset.videotitle && stickyHeroPlayerDisclaimer.getDisclaimerElement() && !isVideoArticlePage()) {
    unHideElement(stickyHeroPlayerDisclaimer.getDisclaimerElement());
  }
};

export const disableStickyElement = () => {
  const $playerCloseButton = $player.querySelector(`.${PLAYER_CLOSE_BUTTON_CLASSNAME}`);
  if (isMobile() && !isLMPArticle) {
    $heroStickyPlayerWrapper.style.removeProperty('top');
    $heroStickyPlayerWrapper.style.removeProperty('height');
    if (!isReadingProgressInPage()) {
      $heroStickyPlayerWrapper.classList.remove(MEDIA_WRAPPER_TOP_BG_CLASSNAME);
    }
  }

  if ($playerCloseButton) {
    hideElement($playerCloseButton);
  }

  $heroStickyPlayerWrapper.classList.remove(
    isMobile() && isLMPArticle ? HERO_STICKY_PLAYER_WRAPPER_LMP_CLASSNAME : HERO_STICKY_PLAYER_WRAPPER_CLASSNAME
  );

  if ($player.dataset.videotitle && stickyHeroPlayerDisclaimer.getDisclaimerElement() && !isVideoArticlePage()) {
    hideElement(stickyHeroPlayerDisclaimer.getDisclaimerElement());
  }
};

export const removeCloseButton = () => {
  const $closeButton = $player.querySelector(`.${PLAYER_CLOSE_BUTTON_CLASSNAME}`);
  $closeButton && $closeButton.remove();
};

const renderCloseButton = () => {
  const $closeButton = document.createElement('a');
  $closeButton.classList.add(PLAYER_CLOSE_BUTTON_CLASSNAME, 'j-player-card__close');
  $closeButton.innerHTML =
    '<i class="icon icon--navigation icon--close icon--xsmall icon--c-light"><svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" class="icon__svg icon__svg--close" fill="currentColor" width="80" height="80"><path d="M39.8 31.84L71.64 0l7.96 7.96L47.76 39.8 80 72.04 72.04 80 39.8 47.76 7.96 79.6 0 71.64 31.84 39.8.4 8.36 8.36.4 39.8 31.84z" fill="currentColor" fill-rule="evenodd"></path></svg></i>';
  return $closeButton;
};

export const appendCloseButton = (players) => {
  const $existingCloseButton = $player.querySelector('.c-player-card__close');

  if ($existingCloseButton) {
    return;
  }
  const playerInstance = getVideoPlayer(players);
  const $closeButton = renderCloseButton();
  $player.appendChild($closeButton);
  if (!isSticky()) {
    hideElement($closeButton);
  }

  $closeButton.addEventListener('click', () => {
    playerInstance.pause();
    removeCloseButton();
    if (isWidthDeviceMobileTablet()) {
      disableStickyElement();
    } else {
      disableStickyElement();
    }
    satelliteTracker.trackInWeb('generic_interaction', { interaction_name: 'video-sticky-closed' });
    stickyHeroPlayerState.setState('hasUserRejectedSticky', true);
  });
};

export const elementToObserve = () => {
  switch (true) {
    case isMobile() && !isLMPArticle:
      return $sectionDividerSpecial || $globalNav;
    case isMobile() && Boolean(isLMPArticle):
      return $LMPPlayerWrapperMobile;
    default:
      return $playerContainer;
  }
};
